module.exports = __webpack_public_path__ + "img/zqx_icon.2b0d861b.png";